import { useSelector } from 'react-redux';
import { ApplicationState } from '../../rootStore';
import { YearState } from './yearTypes';
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from '@/main/services/reducerUtils';

export const useYearReducer = (keyReducer: string = 'default') => {
  const returnSelector = useSelector((state: ApplicationState) => state.year);
  if (keyReducer === 'default')
    return returnSelector as IReducerWithIsolated<YearState>;

  const updateState = {
    ...returnSelector,
    isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA
  };

  return updateState as IReducerWithIsolated<YearState>;
};

